import React, { useContext, useEffect, useState, useCallback, useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TextField,
  Grid,
  MenuItem,
  InputAdornment,
  Pagination,
  Stack,
  Backdrop,
  useTheme,
  Tooltip,
  Menu,
  MenuList,
  Checkbox,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import DownloadIcon from "@mui/icons-material/Download";
import { useLocation, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import { PreferencesContext } from "../../PreferencesContext";
import MissingConsumer from "../../Components/MissingConsumer";
import { ExportFilesFunction, numberFormat } from "../../shared/CommonFuctions";
import { KeyboardArrowDownSharp, SwitchCamera } from "@mui/icons-material";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import SplashComponent from "../../Navigation/splash";
import { AlertType } from "../../shared/Modal/AlertType";
import MultiSelectSim from "../../Components/MultiSelectSimple";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import {
  GetProductList,
  GetProductListforBatchwiseListReport,
  GetProductListForSale,
} from "../../Services/CategoryProductService";
import { StyledMenu } from "../../Components/StyleMenus";
import { format } from "date-fns";
import AsyncSelect from "react-select/async";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import { GetSaleDetailsByProduct } from "../../Services/SaleService";
import { parametersForSalePage } from "../../StaticData/common";
import { GetSaleDetailsByProductReport } from "../../Services/ReportService";
import { GetBuyerList } from "../../Services/BuyerService";
import { GetWarehouseList } from "../../Services/WarehouseService";
import { GetProductCompanyList } from "../../Services/ProductCompanyService";
import makeAnimated from "react-select/animated";
import MultiSelect from "../../Components/MultiSelect";
import CustomColumn from "../../Assets/custom-column.svg";

const COLUMN_STORAGE_KEY = "SALE_DETAILS_BY_PRODUCT_COLUMNS";

type ColumnKey =
  | "SALE_NUMBER"
  | "SALE_DATE"
  | "PRODUCT_NAME"
  | "COMPANY"
  | "BATCH_EXPIRY"
  | "WAREHOUSE_NAME"
  | "CUSTOMER"
  | "FREE_QUANTITY"
  | "QUANTITY"
  | "TOTAL_QUANTITY"
  | "SALE_AMOUNT"
  | "PROFIT_AMOUNT"
  | "PROFIT_PERCENT";

interface Data {
  saleNumber: string;
  staff_code: string;
  sale_Id: Number;
  fullName: string;
}
const saleList: Data = {
  saleNumber: "",
  staff_code: "",
  sale_Id: 0,
  fullName: "",
};
type Order = "asc" | "desc" | "";

const parameters: any = {
  consumerId: 25,
  branchId: 1,
  pageIndex: 1,
  pageSize: PAGE_SIZE,
  sortColumn: "",
  sortDirection: "",
  searchValue: "",
  lessThanValue: "",
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort<T>(
  array: readonly T[],
  comparator: (a: T, b: T) => number
) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
function getComparator<Key extends keyof any>(
  order: Order,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const SaleDetailsByProduct = () => {
  let urlParams = useQuery();
  const edService = new EncryptDecryptService();
  let tempEncryptedConvertTimeCategoryId = urlParams.get("q");
  let decryptProductId: any = edService.decrypt(
    tempEncryptedConvertTimeCategoryId
  );
  let convertedCProductId: any = parseInt(decryptProductId) || 0;

  const theme = useTheme();
  const [param, setParam] = useState(parameters);
  let navigate = useNavigate();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGE_SIZE);
  const [value, setValue] = useState("");
  const { userContext, updateUserContext } =
    React.useContext(PreferencesContext);
  const matches = useMediaQuery("(max-width:425px)");
  const [isLoading, setLoading] = React.useState(false);
  const [pageName, setPageName] = React.useState("Sales Details By Product");
  const [dense, setDense] = React.useState(false);
  const [page_Index, setPage_Index] = useState(1);
  const [counData, setCounData] = useState(0);
  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const [Curr_page, setCurrPage] = React.useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageStartIndex, setPageStartIndex] = useState(1);
  const [pageEndIndex, setPageEndIndex] = useState(1);
  const [resultData, setResultData] = useState<any>(saleList);
  const [productSelectedOption, setProductSelectedOption] = React.useState<any>(
    []
  );
  const [ProductCollection, setProductCollection] = useState<any>([]);
  const [warehouseCollection, setWarehouseCollection] = useState<any>([]);

  const [selectedProductIdData, setSelectedProductIdData] = React.useState<any>(
    []
  );
  const animatedComponents = makeAnimated();
  const [selectedWarehouseIdData, setSelectedWarehouseIdData] =
    React.useState<any>([]);
  const [warehouseSelectedOption, setWarehouseSelectedOption] =
    React.useState<any>([]);
  const [customersSelectedOption, setCustomerssSelectedOption] =
    React.useState<any>([]);
  const [CustomerCollection, setCustomerCollection] = useState<any>([]);
  const [selectedCustomerIdData, setselectedCustomerIdData] =
    React.useState<any>([]);
  const [selectedProductCompanyIdData, setSelectedProductCompanyIdData] =
    React.useState<any>("");
  const [productCompanyCollection, setProductCompanyCollection] = useState<any>([]);
  const [selectedCompanies, setSelectedCompanies] = useState<any[]>([]);
  const [companiesSelectedOption, setCompaniesSelectedOption] =
    React.useState<any>([]);
  const [inputCompanyValue, setInputCompanyValue] = useState("");
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  // --- Customize Columns ---
  const columnDefinitions = useMemo(
    () => [
      { key: "SALE_NUMBER" as ColumnKey, label: "Sale Number" },
      { key: "SALE_DATE" as ColumnKey, label: "Sale Date" },
      { key: "PRODUCT_NAME" as ColumnKey, label: "Product Name" },
      { key: "COMPANY" as ColumnKey, label: "Company" },
      { key: "BATCH_EXPIRY" as ColumnKey, label: "Batch/Expiry" },
      { key: "WAREHOUSE_NAME" as ColumnKey, label: "Warehouse Name" },
      { key: "CUSTOMER" as ColumnKey, label: "Customer" },
      {
        key: "FREE_QUANTITY" as ColumnKey,
        label: "Free Quantity",
        requiresFreeQuantity: true,
      },
      { key: "QUANTITY" as ColumnKey, label: "Quantity" },
      {
        key: "TOTAL_QUANTITY" as ColumnKey,
        label: "Total Quantity",
        requiresFreeQuantity: true,
      },
      { key: "SALE_AMOUNT" as ColumnKey, label: "Sale Amount" },
      { key: "PROFIT_AMOUNT" as ColumnKey, label: "Profit Amt. (₹)" },
      { key: "PROFIT_PERCENT" as ColumnKey, label: "Profit (%)" },
    ],
    [],
  );

  const availableColumns = useMemo(
    () =>
      columnDefinitions.filter(
        (column) =>
          !column.requiresFreeQuantity || userContext.enableFreeQuantity,
      ),
    [columnDefinitions, userContext.enableFreeQuantity],
  );

  const buildDefaultColumnConfig = useCallback(() => {
    return availableColumns.reduce(
      (acc, column) => {
        acc[column.key] = true;
        return acc;
      },
      {} as Record<ColumnKey, boolean>,
    );
  }, [availableColumns]);

  const loadStoredColumnConfig = useCallback(() => {
    if (typeof window === "undefined") {
      return buildDefaultColumnConfig();
    }
    try {
      const rawValue = window.localStorage.getItem(COLUMN_STORAGE_KEY);
      if (!rawValue) {
        return buildDefaultColumnConfig();
      }
      const parsed = JSON.parse(rawValue);
      if (!parsed || typeof parsed !== "object") {
        return buildDefaultColumnConfig();
      }
      return availableColumns.reduce(
        (acc, column) => {
          const storedValue = parsed[column.key];
          acc[column.key] =
            typeof storedValue === "boolean" ? storedValue : true;
          return acc;
        },
        {} as Record<ColumnKey, boolean>,
      );
    } catch {
      return buildDefaultColumnConfig();
    }
  }, [availableColumns, buildDefaultColumnConfig]);

  const [columnConfig, setColumnConfig] = useState<Record<ColumnKey, boolean>>(
    () => loadStoredColumnConfig(),
  );
  const [columnConfigDraft, setColumnConfigDraft] = useState<
    Record<ColumnKey, boolean>
  >(() => loadStoredColumnConfig());

  const persistColumnConfig = useCallback(
    (nextConfig: Record<ColumnKey, boolean>) => {
      if (typeof window === "undefined") {
        return;
      }
      window.localStorage.setItem(
        COLUMN_STORAGE_KEY,
        JSON.stringify(nextConfig),
      );
    },
    [],
  );

  const handleSettingsOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
    setColumnConfigDraft(columnConfig);
  };

  const handleSettingsClose = () => {
    setMenuAnchorEl(null);
    setColumnConfigDraft(columnConfig);
  };

  const handleSettingsSave = () => {
    setColumnConfig(columnConfigDraft);
    persistColumnConfig(columnConfigDraft);
    setMenuAnchorEl(null);
  };
  // --- End Customize Columns ---

  const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [fromDate, setFromDate] = React.useState<any>(
    userContext.financialYearStartDate
  );
  const [toDate, setToDate] = React.useState<any>(
    userContext.financialYearEndDate
  );

  const openExportType = Boolean(anchorEl2);
  const handleCloseExportType = () => {
    setAnchorEl2(null);
  };
  const [order, setOrder] = React.useState<Order>("");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("none");

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const mobile = useMediaQuery("(max-width:320px)");
  const mobile1 = useMediaQuery("(max-width:375px)");
  const mobile2 = useMediaQuery("(max-width:425px)");
  const tablet = useMediaQuery("(max-width:768px)");
  const tablet2 = useMediaQuery("(max-width:1024px)");
  const largeScreen = useMediaQuery("(max-width:1440px)");
  const tableMaxWidth = mobile
    ? "100vw"
    : mobile1
      ? "100vw"
      : mobile2
        ? "100vw"
        : tablet
          ? "calc(100vw - 40px)"
          : tablet2
            ? "calc(100vw - 80px)"
            : largeScreen
              ? "calc(100vw - 140px)"
              : "calc(100vw - 180px)";

  function EnhancedTableHead(props: EnhancedTableProps) {
    return (
      // checkBox for Header
      <TableHead>
        <TableRow>
          {columnConfig.SALE_NUMBER && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "140px",
              }}
              align="left"
            >
              {"Sale Number"}
            </TableCell>
          )}
          {columnConfig.SALE_DATE && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "140px",
              }}
              align="center"
            >
              {"Sale Date"}
            </TableCell>
          )}
          {columnConfig.PRODUCT_NAME && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "140px",
              }}
              align="left"
            >
              {"Product Name"}
            </TableCell>
          )}
          {columnConfig.COMPANY && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "140px",
              }}
              align="left"
            >
              {"Company"}
            </TableCell>
          )}
          {columnConfig.BATCH_EXPIRY && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "140px",
              }}
              align="left"
            >
              {"Batch/Expiry"}
            </TableCell>
          )}
          {columnConfig.WAREHOUSE_NAME && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "140px",
              }}
              align="left"
            >
              {"Warehouse Name"}
            </TableCell>
          )}
          {columnConfig.CUSTOMER && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="left"
            >
              {"Customer"}
            </TableCell>
          )}
          {userContext.enableFreeQuantity && columnConfig.FREE_QUANTITY && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              {"Free Quantity"}
            </TableCell>
          )}
          {columnConfig.QUANTITY && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              {"Quantity"}
            </TableCell>
          )}
          {userContext.enableFreeQuantity && columnConfig.TOTAL_QUANTITY && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              {"Total Quantity"}
            </TableCell>
          )}
          {columnConfig.SALE_AMOUNT && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              {"Sale Amount"}
            </TableCell>
          )}
          {columnConfig.PROFIT_AMOUNT && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              {"Profit Amt. (₹)"}
            </TableCell>
          )}
          {columnConfig.PROFIT_PERCENT && (
            <TableCell
              sx={{
                display: {
                  xs: "table-cell",
                  sm: "table-cell",
                  md: "table-cell",
                  lg: "table-cell",
                },
                fontWeight: "bold",
                minWidth: "80px",
              }}
              align="right"
            >
              {"Profit (%)"}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
    );
  }

  const handleChangePageNew = (
    event: React.ChangeEvent<unknown>,
    value: number
    //values: number
  ) => {
    if (Curr_page !== value) {
      setCurrPage(value);
      setPage_Index(value);
      setParam({ ...param, pageIndex: value });
    }
  };

  const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  async function fetchProductCompanyList() {
    try {
      let params = new URLSearchParams();
      let companyList: any;
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", page_Index.toString());
      params.append("pageSize", param.pageSize);
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "DROPDOWN");

      const result: any = await GetProductCompanyList(params);
      if (result && result.data.data) {
        companyList = result.data?.data?.productCompanyCollection;
        setProductCompanyCollection(companyList);
      } else {
      }
      return companyList;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function filterProductCompany(inputValue: string) {
    try {
      let params = new URLSearchParams();
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", "1");
      params.append("pageSize", "50");
      params.append("sortColumn", "");
      params.append("sortDirection", "");
      params.append("searchValue", inputValue);
      params.append("mode", "DROPDOWN");

      const result: any = await GetProductCompanyList(params);
      if (result && result.data.data) {
        return result.data?.data?.productCompanyCollection;
      }
      return [];
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
      return [];
    }
  }

  const loadFilterCompanyOptions = (
    inputValue: string,
    callback: (options: any) => void
  ) => {
    if (inputValue && inputValue.length > 0) {
      filterProductCompany(inputValue).then((r) => {
        callback(r);
      });
    } else {
      callback([]);
    }
  };


  function searchValue(val: any) {
    if (val === "") {
      setValue("");
    }
    setPage_Index(1);
    setParam({ ...param, searchValue: val.toString(), pageIndex: 1 });
  }

  interface EnhancedTableProps {
    order: Order;
    orderBy: String;
    rowCount: number;
  }
  const handleWarehouseId = (object: any) => {
    setWarehouseSelectedOption(object);
    let warehouseIdData: any = [];

    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let warehouseIds = x.warehouseId;
        x.warehouseId = warehouseIds;
        warehouseIdData.push(warehouseIds.toString());
      }
    });
    setSelectedWarehouseIdData(warehouseIdData);
  };

  const handleChangeCompany = (object: any[]) => {
    setCompaniesSelectedOption(object);

    let tempCompanyIdData: any = [];

    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let companyId = x.productCompanyId;
        tempCompanyIdData.push(companyId.toString());
      }
    });

    setSelectedProductCompanyIdData(tempCompanyIdData);
  };

  const handleChangeCategory = (object: any) => {
    setProductSelectedOption(object);
    let tempCustomerIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let productId = x.productId;
        x.productId = productId;
        tempCustomerIdData.push(productId.toString());
      }
    });
    setSelectedProductIdData(tempCustomerIdData);
  };
  const handleChangeCategortwo = (object: any) => {
    setCustomerssSelectedOption(object);
    let tempCustomerIdData: any = [];
    object.forEach((x) => {
      if (x?.value === "*") {
        return;
      } else {
        let buyerIds = x.buyerId;
        x.buyerId = buyerIds;
        tempCustomerIdData.push(buyerIds.toString());
      }
    });
    setselectedCustomerIdData(tempCustomerIdData);
  };

  async function saleEdit(saleid: any) {
    try {
      let encSaleId: any = edService.encrypt(saleid);
      navigate(
        {
          pathname: "/invoice-save",
          search: `?q=${encodeURIComponent(encSaleId)}&t=${"tax-invoice"}`,
        },
        {
          state: { title: " Edit Invoice", button: "Update", saleId: saleid },
        }
      );
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function GetProductLists() {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", parametersForSalePage.pageIndex.toString());
    params.append("pageSize", "5000");
    params.append("sortColumn", parametersForSalePage.sortColumn);
    params.append("sortDirection", parametersForSalePage.sortDirection);
    params.append("financialYear", userContext.financialYear.toString());
    // params.append("saleDate",'');

    try {
      let productCollection: any;
      const result: any = await GetProductList(params);
      if (result && result.data.data) {
        productCollection = result.data.data.productCollection;
        setProductCollection(productCollection);
      } else {
      }
      return productCollection;
    } catch (e: any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }
  async function fetchWarehouseList() {
    try {
      let params = new URLSearchParams();
      let warehouseList: any;
      params.append("consumerId", userContext.consumerId.toString());
      params.append("firmId", userContext.firmId.toString());
      params.append("branchId", userContext.branchId.toString());
      params.append("pageIndex", page_Index.toString());
      params.append("pageSize", param.pageSize);
      params.append("sortColumn", param.sortColumn);
      params.append("sortDirection", param.sortDirection);
      params.append("searchValue", param.searchValue);
      params.append("mode", "");

      const result: any = await GetWarehouseList(params);
      if (result && result.data.data) {
        warehouseList = result.data?.data?.warehouseCollection;
        setWarehouseCollection(warehouseList);
      } else {
      }
      return warehouseList;
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  async function fetchSaleList() {
    let params = new URLSearchParams();

    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", page_Index.toString());
    params.append("pageSize", param.pageSize);
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", param.searchValue);
    params.append("financialYear", userContext.financialYear);
    if (
      convertedCProductId > 0 &&
      selectedProductIdData?.length === 0 &&
      productSelectedOption?.length !== 0
    ) {
      params.append("ProductId", convertedCProductId.toString); //changes after that
    } else {
      params.append("ProductId", selectedProductIdData);
    }
    if (selectedProductCompanyIdData) {
      params.append("productCompanyIds", selectedProductCompanyIdData);
    }
    params.append("CustomerId", selectedCustomerIdData);
    params.append("warehouseId", selectedWarehouseIdData);
    params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
    params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));

    setLoading(true);
    try {
      const result: any = await GetSaleDetailsByProduct(params);
      let endIndex: any;

      if (
        result &&
        result.data.data &&
        result.data.data.saleDetailsProductListCollection
      ) {
        let saleDetailsProductListCollection =
          result.data.data.saleDetailsProductListCollection;
        let dataCount = result.data.data.totalCount;
        let showDataCount = Math.ceil(dataCount / PAGE_SIZE);
        let startIndex = (page_Index - 1) * param.pageSize + 1;
        endIndex =
          (page_Index - 1) * param.pageSize +
          (saleDetailsProductListCollection
            ? saleDetailsProductListCollection.length
            : 0);
        setResultData(saleDetailsProductListCollection);
        setCounData(showDataCount);
        setPageStartIndex(startIndex);
        setPageEndIndex(endIndex);
        setTotalCount(dataCount);
      }
    } catch (e: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
    setLoading(false);
  }

  async function openSalesReportPopup(type: any) {
    setAnchorEl2(null);
    setLoading(true);
    let params = new URLSearchParams();
    var attachmentName = "";
    if (type === "pdf") {
      attachmentName = "SaleDetailsByProduct.pdf";
    } else {
      attachmentName = "SaleDetailsByProduct.xls";
    }
    params.append("reportName", "SaleDetailsByProductReport");
    params.append("reportType", type);
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("sortColumn", param.sortColumn);
    params.append("sortDirection", param.sortDirection);
    params.append("searchValue", param.searchValue);
    params.append("financialYear", userContext.financialYear);
    params.append("isFreeQuantity", userContext.enableFreeQuantity.toString());
    params.append("fileName", attachmentName);
    params.append("isForDownload", "1");
    if (
      convertedCProductId > 0 &&
      selectedProductIdData?.length === 0 &&
      productSelectedOption?.length !== 0
    ) {
      params.append("ProductId", convertedCProductId.toString);
    } else {
      params.append("ProductId", selectedProductIdData);
    }
    params.append("productCompanyIds", selectedProductCompanyIdData);
    params.append("CustomerId", selectedCustomerIdData);
    params.append("warehouseId", selectedWarehouseIdData);
    params.append("mode", "EXPORT");
    params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
    params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
    params.append("isProfitDetail", columnConfig.PROFIT_AMOUNT ? true : false);
    try {
      const result: any = await GetSaleDetailsByProductReport(params);

      if (result && result.data && result.data.data) {
        var fileContent = result?.data?.data?.fileData;
        var attachmentData = fileContent;
        ExportFilesFunction(attachmentName, type, attachmentData);
        setLoading(false);
      }
      setLoading(false);
    } catch (e: any) {
      // setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
      setLoading(false);
    }
  }

  async function GetCustomerList() {
    setLoading(true);
    let params = new URLSearchParams();
    params.append("consumerId", userContext.consumerId.toString());
    params.append("firmId", userContext.firmId.toString());
    params.append("branchId", userContext.branchId.toString());
    params.append("pageIndex", parametersForSalePage.pageIndex.toString());
    params.append("pageSize", parametersForSalePage.pageSize.toString());
    params.append("sortColumn", parametersForSalePage.sortColumn);
    params.append("sortDirection", parametersForSalePage.sortDirection);
    params.append("financialYear", userContext.financialYear?.toString());

    try {
      let categoryInfo: any;
      const result: any = await GetBuyerList(params);
      if (result && result.data.data) {
        categoryInfo = result.data?.data?.buyerCollection;
        setCustomerCollection(categoryInfo);
      } else {
      }
      return categoryInfo;
    } catch (e: any) {
      setLoading(false);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage:
          typeof e === "string" ? (e as string) : (e?.message as string),
        alertType: AlertType.Error,
      });
    }
  }

  useEffect(() => {
    const productId = async () => {
      const productData = await GetProductLists();
      if (convertedCProductId > 0 && convertedCProductId) {
        const filteroption: any = productData?.filter((x) => {
          return x.productId === convertedCProductId;
        });

        setProductSelectedOption(filteroption);
        setSelectedProductIdData(convertedCProductId.toString());
        handleChangeCategory(filteroption);
      }
    };
    productId();
    // fetchWarehouseList();
    GetCustomerList();
  }, []);

  useEffect(() => {
    fetchSaleList();
    fetchProductCompanyList();
    GetProductLists();
    fetchWarehouseList();
  }, [param, selectedProductIdData, fromDate, toDate, selectedCustomerIdData, selectedWarehouseIdData, selectedProductCompanyIdData]);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          backgroundColor: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <SplashComponent />
      </Backdrop>

      <Title pageTitle={pageName} />

      {userContext.consumerId > 0 ? (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}
        >
          <Grid
            className="title-button-responsive"
            item
            xs={6}
            md={3}
            sx={{
              display: "flex !important",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4 className="page-title">{pageName}</h4>

            <Grid
              item
              xs={6}
              md={3}
              marginRight={0}
              textAlign="end"
              paddingTop="0px"
            >
              <Button
                // color="primary"
                variant="outlined"
                onClick={() => navigate(-1)}
                size="medium"
              >
                <ShortcutButton label="ESC" />
                Back
              </Button>
            </Grid>
          </Grid>
          <Grid className="paper top-space">
            <Paper elevation={4} className="paper-container">

              <Grid
                container
                spacing={1}
                sx={{ marginTop: "10px" }}
                className="search-space"
              >
                <Grid item xs={12} sm={12} md={4} lg={2} xl={2}>
                  <TextField
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        searchValue(value);
                      }
                    }}
                    sx={{ paddingLeft: "0px !important", width: "100%" }}
                    className="button-responsive-stock"
                    placeholder="Search..."
                    type="text"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => searchValue(value)}>
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),

                      endAdornment: value && (
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => searchValue("")}
                        >
                          <ClearIcon />
                        </IconButton>
                      ),
                    }}
                  />
                </Grid>

                <Grid sx={{
                  display: matches ? "" : "flex",
                  gap: "10px",
                }}
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={5}
                  xl={5}>
                  <Grid>
                    <MultiSelect
                      key="BuyerId"
                      placeholderLabel="Products"
                      placeholder="Select Product.."
                      options={ProductCollection}
                      onChange={handleChangeCategory}
                      value={productSelectedOption}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                    />
                  </Grid>
                  <Grid marginTop={matches ? "10px" : ""}>
                    <MultiSelect
                      key="BuyerId"
                      placeholderLabel="Customers"
                      placeholder="Select Customer.."
                      options={CustomerCollection}
                      onChange={handleChangeCategortwo}
                      value={customersSelectedOption}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                    />
                  </Grid>
                  <Grid marginTop={matches ? "10px" : ""}>
                    <MultiSelect
                      key="WarehouseId"
                      placeholderLabel="Warehouses"
                      placeholder="Select Warehouse.."
                      options={warehouseCollection}
                      onChange={handleWarehouseId}
                      value={warehouseSelectedOption}
                      isSelectAll={true}
                      menuPlacement={"bottom"}
                    />
                  </Grid>
                  <Grid marginTop={matches ? "10px" : ""}>
                    <MultiSelect
                      key="ProductCompanyId"
                      placeholderLabel="Company"
                      placeholder="Select Company.."
                      options={productCompanyCollection}
                      onChange={handleChangeCompany}
                      value={companiesSelectedOption}
                      isSelectAll={true}
                      menuPlacement="bottom"
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                  <Grid
                    sx={{
                      display: "flex",
                      justifyContent: { xs: "stretch", md: "flex-end" },
                      alignItems: { xs: "stretch", md: "flex-start", lg: "center" },
                      gap: "5px",
                      flexWrap: "wrap",
                      "& > div, & > button, & > Box": {
                        width: { xs: "100%", md: "auto" },
                      },
                    }}
                  >
                    <CustomDateRangePicker
                      sx={{ marginTop: matches ? "10px !important" : "" }}
                      fromDate={fromDate}
                      setFromDate={setFromDate}
                      toDate={toDate}
                      setToDate={setToDate}
                      minDate={dayjs(userContext.financialYearStartDate)}
                      maxDate={dayjs(userContext.financialYearEndDate)}
                    />
                    <Button
                      className="button-responsive-stock"
                      aria-controls={
                        openExportType ? "demo-customized-menu" : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={openExportType ? "true" : undefined}
                      disabled={resultData?.length <= 0 ? true : false}
                      variant="outlined"
                      disableElevation
                      onClick={handleClickExportType}
                      startIcon={<DownloadIcon />}
                      endIcon={<KeyboardArrowDownSharp />}
                    >
                      Export
                    </Button>
                    <StyledMenu
                      id="demo-customized-menu"
                      MenuListProps={{
                        "aria-labelledby": "demo-customized-button",
                      }}
                      anchorEl={anchorEl2}
                      open={openExportType}
                      onClose={handleCloseExportType}
                    >
                      <MenuItem
                        disableRipple
                        onClick={() => {
                          openSalesReportPopup("pdf");
                        }}
                      >
                        PDF
                      </MenuItem>
                      <MenuItem
                        disableRipple
                        onClick={() => {
                          openSalesReportPopup("Excel");
                        }}
                      >
                        EXCEL
                      </MenuItem>
                    </StyledMenu>
                    <Box>
                      <Tooltip title="Customize Columns" placement="top">
                        <IconButton
                          aria-label="Settings"
                          onClick={handleSettingsOpen}
                        >
                          <img src={CustomColumn} alt="Settings" height={20} />
                        </IconButton>
                      </Tooltip>
                      <Menu
                        anchorEl={menuAnchorEl}
                        open={Boolean(menuAnchorEl)}
                        MenuListProps={{ disablePadding: true }}
                        onClose={handleSettingsClose}
                      >
                        <MenuList sx={{ padding: 0 }}>
                          <Box
                            sx={{
                              border: "1px solid #c7c5c5",
                              borderRadius: "4px",
                              display: "flex",
                              flexDirection: "column",
                              overflow: "hidden",
                            }}
                          >
                            <Box
                              sx={{
                                backgroundColor: "#dee6fa",
                                color: "#404d54",
                                padding: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              Settings
                            </Box>
                            <Box
                              sx={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {availableColumns.map((column) => (
                                <MenuItem
                                  key={column.key}
                                  sx={{
                                    alignItems: "start",
                                    paddingLeft: "5px",
                                  }}
                                  onClick={() =>
                                    setColumnConfigDraft((prev) => ({
                                      ...prev,
                                      [column.key]: !prev[column.key],
                                    }))
                                  }
                                >
                                  <Checkbox
                                    checked={columnConfigDraft[column.key]}
                                    sx={{
                                      padding: 0,
                                      margin: 0,
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: "13px !important",
                                      fontWeight: "normal",
                                      paddingLeft: "8px",
                                    }}
                                  >
                                    {column.label}
                                  </Typography>
                                </MenuItem>
                              ))}
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                borderTop: "1px solid #ccc",
                                px: 2,
                                py: 1,
                                gap: "5px",
                              }}
                            >
                              <Button
                                size="small"
                                onClick={handleSettingsSave}
                                color="primary"
                                variant="contained"
                              >
                                Save
                              </Button>
                              <Button
                                onClick={handleSettingsClose}
                                size="small"
                              >
                                Close
                              </Button>
                            </Box>
                          </Box>
                        </MenuList>
                      </Menu>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

              <TableContainer
                sx={{
                  width: 'auto',
                  maxWidth: '100vw',
                  overflowX: 'auto'
                }}
              >
                <Table
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  sx={{ minWidth: 1024 }}
                >
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    rowCount={resultData?.length}
                  />

                  {resultData?.length > 0 && (
                    <TableBody>
                      {stableSort(resultData, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((item: any, index: any) => {
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={index + 1}
                            >
                              {columnConfig.SALE_NUMBER && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="left"
                                >
                                  <Button
                                    disableRipple
                                    sx={{ justifyContent: "left" }}
                                    className="manuButton-link"
                                    color="primary"
                                    onClick={() => saleEdit(item.saleId)}
                                  >
                                    {item?.saleNumber}
                                  </Button>
                                </TableCell>
                              )}
                              {columnConfig.SALE_DATE && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="center"
                                >
                                  {item?.saleDate}
                                </TableCell>
                              )}

                              {columnConfig.PRODUCT_NAME && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="left"
                                >
                                  {item?.productName}
                                </TableCell>
                              )}
                              {columnConfig.COMPANY && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="left"
                                >
                                  {item?.productCompanyName}
                                </TableCell>
                              )}
                              {columnConfig.BATCH_EXPIRY && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="left"
                                >
                                  {item?.batch}
                                </TableCell>
                              )}
                              {columnConfig.WAREHOUSE_NAME && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="left"
                                >
                                  {item?.warehouseName}
                                </TableCell>
                              )}
                              {columnConfig.CUSTOMER && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="left"
                                >
                                  {item?.buyerName}
                                </TableCell>
                              )}
                              {userContext.enableFreeQuantity && columnConfig.FREE_QUANTITY && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="right"
                                >
                                  {numberFormat(item?.freeQuantity, 3, 3)}
                                </TableCell>
                              )}
                              {columnConfig.QUANTITY && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="right"
                                >
                                  {numberFormat(item?.quantity, 3, 3)}
                                </TableCell>
                              )}
                              {userContext.enableFreeQuantity && columnConfig.TOTAL_QUANTITY && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="right"
                                >
                                  {numberFormat(item?.totalQuantity, 3, 3)}
                                </TableCell>
                              )}
                              {columnConfig.SALE_AMOUNT && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="right"
                                >
                                  {numberFormat(item?.saleAmount, 2, 2)}
                                </TableCell>
                              )}
                              {columnConfig.PROFIT_AMOUNT && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="right"
                                >
                                  {numberFormat(item?.differenceAmount, 2, 2)}
                                </TableCell>
                              )}
                              {columnConfig.PROFIT_PERCENT && (
                                <TableCell
                                  sx={{
                                    display: {
                                      xs: "table-cell",
                                      sm: "table-cell",
                                      md: "table-cell",
                                    },
                                  }}
                                  align="right"
                                >
                                  {numberFormat(item?.differencePercentage, 2, 2) + "%"}
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      {resultData?.length > 0 && (
                        <TableRow hover tabIndex={-1} key={"0"}>
                          {columnConfig.SALE_NUMBER && (
                            <TableCell className="bold-600">Total</TableCell>
                          )}
                          {columnConfig.SALE_DATE && <TableCell>{""}</TableCell>}
                          {columnConfig.PRODUCT_NAME && <TableCell>{""}</TableCell>}
                          {columnConfig.COMPANY && <TableCell>{""}</TableCell>}
                          {columnConfig.BATCH_EXPIRY && <TableCell>{""}</TableCell>}
                          {columnConfig.WAREHOUSE_NAME && <TableCell>{""}</TableCell>}
                          {columnConfig.CUSTOMER && <TableCell>{""}</TableCell>}
                          {userContext.enableFreeQuantity && columnConfig.FREE_QUANTITY && (
                            <TableCell
                              align="right"
                              className="bold-600 "
                              sx={{
                                display: {
                                  xs: "table-cell",
                                  sm: "table-cell",
                                  md: "table-cell",
                                  lg: "table-cell",
                                },
                              }}
                            >
                              {numberFormat(
                                resultData?.reduce(
                                  (acc, curr) =>
                                    acc +
                                    (curr?.freeQuantity
                                      ? curr?.freeQuantity
                                      : 0),
                                  0
                                ), 3, 3
                              )}
                            </TableCell>
                          )}
                          {columnConfig.QUANTITY && (
                            <TableCell
                              align="right"
                              className="bold-600 "
                              sx={{
                                display: {
                                  xs: "table-cell",
                                  sm: "table-cell",
                                  md: "table-cell",
                                  lg: "table-cell",
                                },
                              }}
                            >
                              {numberFormat(
                                resultData?.reduce(
                                  (acc, curr) =>
                                    acc + (curr?.quantity ? curr?.quantity : 0),
                                  0
                                ), 3, 3
                              )}
                            </TableCell>
                          )}
                          {userContext.enableFreeQuantity && columnConfig.TOTAL_QUANTITY && (
                            <TableCell
                              align="right"
                              className="bold-600 "
                              sx={{
                                display: {
                                  xs: "table-cell",
                                  sm: "table-cell",
                                  md: "table-cell",
                                  lg: "table-cell",
                                },
                              }}
                            >
                              {numberFormat(
                                resultData?.reduce(
                                  (acc, curr) =>
                                    acc +
                                    (curr?.totalQuantity
                                      ? curr?.totalQuantity
                                      : 0),
                                  0
                                ), 3, 3
                              )}
                            </TableCell>
                          )}
                          {columnConfig.SALE_AMOUNT && (
                            <TableCell
                              align="right"
                              className="bold-600 "
                              sx={{
                                display: {
                                  xs: "table-cell",
                                  sm: "table-cell",
                                  md: "table-cell",
                                  lg: "table-cell",
                                },
                              }}
                            >
                              {numberFormat(
                                resultData?.reduce(
                                  (acc, curr) =>
                                    acc +
                                    (curr?.saleAmount ? curr?.saleAmount : 0),
                                  0
                                )
                              )}
                            </TableCell>
                          )}
                          {columnConfig.PROFIT_AMOUNT && (
                            <TableCell
                              align="right"
                              className="bold-600 "
                              sx={{
                                display: {
                                  xs: "table-cell",
                                  sm: "table-cell",
                                  md: "table-cell",
                                  lg: "table-cell",
                                },
                              }}
                            >
                              {numberFormat(
                                resultData?.reduce(
                                  (acc, curr) =>
                                    acc +
                                    (curr?.differenceAmount ? curr?.differenceAmount : 0),
                                  0
                                )
                              )}
                            </TableCell>
                          )}
                          {columnConfig.PROFIT_PERCENT && (
                            <TableCell></TableCell>
                          )}
                        </TableRow>
                      )}
                    </TableBody>
                  )}
                </Table>
                {resultData?.length > 0 && (
                  <Grid
                    container
                    paddingTop={1}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Grid item xs={12} sm={6} className="pagination-label">
                      {pageStartIndex} - {pageEndIndex} of {totalCount}
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Stack
                        component="div"
                        alignItems={mobileScreen ? " center" : "end"}
                        justifyContent={"center"}
                      >
                        <Pagination
                          color="primary"
                          count={counData}
                          page={page_Index}
                          onChange={handleChangePageNew}
                        />
                      </Stack>
                    </Grid>
                  </Grid>
                )}
              </TableContainer>
            </Paper>
          </Grid>
        </Box>
      ) : (
        <Box
          className="boxContainer"
          sx={{
            "& > :not(style)": {
              width: "100%",
            },
          }}
        >
          <MissingConsumer consumerId={userContext.consumerId} />
        </Box>
      )}
    </>
  );
};

export default SaleDetailsByProduct;
